import { Action } from 'redux'

export type TMicroservicesState = {
  [microserviceName: string]: string[]
}

export const actionTypes = {
  SET_MICROSERVICES: 'parser/api/setMicroservices',
} as const

export interface TSetMicroservicesAction
  extends Action<typeof actionTypes.SET_MICROSERVICES> {
  payload: Partial<TMicroservicesState>
}

export type TAction = TSetMicroservicesAction
